import { createFileRoute } from '@tanstack/react-router';
import { ErrorState } from '@/components/domain/ErrorState';
import { clusterDetailOptions } from '@/features/clusters/api';
import { ClusterDetailPage } from '@/features/clusters/ClusterDetailPage';
import { ClusterDetailSearch } from '@/lib/search-schemas';

export const Route = createFileRoute('/_auth/clusters/$id')({
  validateSearch: ClusterDetailSearch,
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(clusterDetailOptions(params.id)),
  // 404 ou panne : `ErrorState` dans le shell, « Réessayer » relance le loader.
  errorComponent: ({ error, reset }) => <ErrorState error={error} onRetry={reset} />,
  component: ClusterDetailPage,
});
